export const FACULTIES = "FACULTIES";
export const FACULTIES_ARE_LOADING = "FACULTIES_ARE_LOADING";
